import React, { Component } from 'react';
import { TextField, Label, DefaultButton } from '@fluentui/react';
import { UTCDateTimeNow } from './Helper/Common';
import { UnsubscribeInfo } from './Helper/DataType';
import * as msg from './Helper/Const';

export class UnsubscribeForm extends Component {
    static displayName = UnsubscribeForm.name;

    constructor(props) {
        super(props);
        this.state = {
            guestID: props.match.params.id,
            email: '',
            isEmailExist: true,
            submit: false,
            loading: true
        };
    }

    componentDidMount() {
        this.getUnsubscribeEmail();
    }

    onUnsubscribeClicked = () => {
        let info = UnsubscribeInfo();
        info.Email = this.state.email;
        info.ResponsedDate = UTCDateTimeNow();

        var unsubscribeInfo = JSON.stringify(info);
        this.unsubscribe(unsubscribeInfo);
    }

    /* Get email given id
     */
    async getUnsubscribeEmail() {
        // system maintenence
        const configResponse = await fetch('unsubscribe/getConfigSettings');
        if (configResponse.ok) {
            const systemMaintenance = await configResponse.text();
            if (systemMaintenance === "true") {
                this.props.history.push('/maintenence');
                return;
            }
        }

        const response = await fetch(`unsubscribe/${this.state.guestID}`);
        if (response.ok) {
            const emailAddress = await response.text();
            this.setState({
                email: emailAddress,
                isEmailExist: emailAddress.length === 0 ? false : true,
                loading: false
            });
        }
    }

    /* Save Unsubscribe information to DB and show UnsubscribeSuccess component 
     */
    async unsubscribe(unsubscribeInfo) {
        const response = await fetch('unsubscribe',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: unsubscribeInfo
            });

        if (response.ok) {
            this.setState({ submit: true });
        }
    }

    render() {
        return (
            <div>{this.state.loading ? <div> </div> :
                <div className="formColumnRight">
                    {this.state.submit ?
                        <div>
                            <Label className="subtitle">{msg.UnsubscribeSuccessTitle}</Label>
                            <br />
                            <Label className="labelInfo">{msg.UnsubscribeSuccess}</Label>
                        </div> :
                        <div>
                            <Label className="title">{msg.UnsubscribeTitle}</Label>
                            <br />
                            { this.state.isEmailExist === true ?
                                <div>
                                    <Label className="labelInfo">{msg.Unsubscribe}</Label><br />
                                    <TextField className="textFieldInfo" readonly label="Email" value={this.state.email} /><br/><br/>
                                    <DefaultButton text="Unsubscribe" onClick={this.onUnsubscribeClicked} />
                                </div>:
                                <div>
                                    <Label className="labelInfo">{msg.UnsubscribeMailNotFound}</Label><br />
                                </div>
                            }
                            <br/>
                        </div>
                    }
                </div>
            }</div>            
        );
    }
}